import { DirectionalLight, HemisphereLight, Scene, Vector3 } from 'three';

/**
 * Sky/ground hemisphere fill plus a shadow-casting sun. The sun's shadow
 * frustum is small and kept centred on the player, so shadows stay crisp
 * across the whole (large) city.
 */
export class Lighting {
  private readonly sun: DirectionalLight;

  constructor(scene: Scene) {
    scene.add(new HemisphereLight(0xcfeaff, 0x6b7a55, 0.95));

    this.sun = new DirectionalLight(0xfff4d6, 1.25);
    this.sun.position.set(180, 320, 120);
    this.sun.castShadow = true;
    this.sun.shadow.mapSize.set(2048, 2048);
    const cam = this.sun.shadow.camera;
    cam.near = 10;
    cam.far = 900;
    cam.left = -260;
    cam.right = 260;
    cam.top = 260;
    cam.bottom = -260;
    this.sun.shadow.bias = -0.0004;
    scene.add(this.sun);
    scene.add(this.sun.target);
  }

  /** Keep the shadow-casting sun anchored above the player. */
  followTarget(position: Vector3): void {
    this.sun.position.set(position.x + 180, 320, position.z + 120);
    this.sun.target.position.copy(position);
  }
}
